import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ConceptoPolizaContableDto;
export interface Props {
    value: Entity[];
}

/**Obtiene las columnas del grid */
function columnas(): kea.Grid2Column<Entity>[] {
    return [
        { title: "No. cuenta", cell: x => ({ data: x.NoCuenta }) },
        { title: "Cargo", cell: x => ({ data: kea.formatCurrency(x.Cargo) }) },
        { title: "Abono", cell: x => ({ data: kea.formatCurrency(x.Abono) }) },
        { title: "Descripción", cell: x => ({ data: x.Descripcion }) },
    ];
}


/**
* Listado de ConceptoPolizaContable
*/
class ConceptoPolizaContableListNoRx extends React.PureComponent<Props> {
    render() {
        const cols = columnas();
        return (
            <div>
                <kea.Title titulo="Conceptos" />   
                <kea.Grid2 items={this.props.value} columnas={cols} />
            </div>
        );
    }
}
export const ConceptoPolizaContableList = kea.mapProps(componentToRx(ConceptoPolizaContableListNoRx), x => ({...x, value: x.value || []}));



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/polizas/edit/conceptos.tsx